import { TextField, Button } from '@mui/material';
import { Search } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

export const SearchContainer = styled('div')({
  border: '0.9px solid #E3E5E8',
  boxSizing: 'border-box',
  boxShadow: '0px 0.9px 3.8px rgba(0, 0, 0, 0.2)',
  marginTop: '47px',
  marginLeft: '45px',
  width: 'calc(100% - 90px)',
  height: '105px',
  background: 'white',
  borderRadius: '7px'
});

export const InputField = styled(TextField)({
  marginTop: '25px',
  marginLeft: '25px',
  width: '616px',
  height: '54px',
  '& fieldset': {
    borderRadius: '10px'
  },
  '& label.Mui-focused': {
    color: '#5F65F6'
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderWidth: '1px',
      borderColor: '#5F65F6'
    },
    '&:hover fieldset': {
      borderColor: '#5F65F6'
    }
  }
});

export const SearchButton = styled(Button)({
  width: '130px',
  height: '57px',
  marginTop: '25px',
  marginLeft: '20px',
  borderRadius: '10px',
  backgroundColor: '#5F65F6',
  textTransform: 'none',
  color: '#FFF',
  '&:hover': {
    backgroundColor: '#5F7EF5'
  },
  '&.Mui-disabled': {
    backgroundColor: '#ACADCF',
    color: '#FFF'
  }
});

export const AddProductButton = styled(Button)({
  width: '150px',
  height: '57px',
  marginTop: '25px',
  marginLeft: 'calc(100% - 965px)',
  borderRadius: '10px',
  border: '1px solid rgba(63, 81, 181, 0.5)',
  textTransform: 'none',
  '&:hover': {
    color: '#3F51B5',
    backgroundColor: '#FFF'
  },
});

export const SearchIcon = styled(Search)({});
